export default __webpack_public_path__ + "static/qrm-presentation-kz-7b81ba7e3a0d59cb422168a1aef7b4b2.png";